var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layer',[_c('v-image',{ref:"image",attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }